"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const selection_hooks_1 = require("../../../../selection.hooks");
const ProductLabel_1 = __importDefault(require("../ProductLabel/ProductLabel"));
const product_swatch_1 = __importDefault(require("../../../product-swatch/product-swatch"));
const ProductSelectSwatch_module_scss_1 = __importDefault(require("./ProductSelectSwatch.module.scss"));
/**
 * @param {Object} props
 * @param {string} props.productCode
 * @param {string} props.attributeCode
 * @param {string} props.className
 * @param {('small' | 'medium')} props.size
 * @param {string} props.dataSelector
 * @param {Object} props.epigraphArButtonProps - Object that contains Epigraph components to render
 * @param {import('react').ReactNode} props.epigraphArButtonProps.EpigraphModelViewer - Epigraph Model Viewer Component
 * @param {import('react').ReactNode} props.epigraphArButtonProps.EpigraphModelDisclaimer - Epigraph Model Disclaimer Component
 * @param {Object} props.toggleProps
 * @param {boolean} props.isOutOfStockStyling - Show strikethroughs if the relevant variant is out of stock
 * @returns {import('react').ReactNode}
 */
const ProductSelectSwatch = ({ productCode, attributeCode, className, size, dataSelector, epigraphArButtonProps = {}, toggleProps, isOutOfStockStyling }) => {
    const options = (0, selection_hooks_1.useAttributeOptions)(productCode, attributeCode);
    const variantsForAttribute = (0, selection_hooks_1.useFindVariantsOfAttribute)(productCode, options.code);
    const { EpigraphModelViewer, EpigraphDisclaimer } = epigraphArButtonProps;
    const hideSize = !options;
    const optionElements = (0, react_1.useMemo)(() => {
        return options && options.values.map((value) => {
            const element = {
                attributeCode: options.code,
                label: value.label,
                value: value.code,
                background: value.swatch,
                limitedEdition: value.limitedEdition || false
            };
            if (isOutOfStockStyling) {
                const thisVariant = variantsForAttribute === null || variantsForAttribute === void 0 ? void 0 : variantsForAttribute.find(variant => variant[options.code] === value.code);
                element.isOutOfStock = thisVariant && !thisVariant.inStock;
            }
            return element;
        });
    }, [options]);
    if (hideSize)
        return null; // Make sure this is after all hooks to avoid React errors
    const onChange = (selectedSwatch) => {
        options.setAttributeValue(selectedSwatch);
    };
    const swatchContainerClasses = (0, classnames_1.default)(ProductSelectSwatch_module_scss_1.default.swatchListContainer, {
        [ProductSelectSwatch_module_scss_1.default.arContainer]: EpigraphModelViewer,
        [ProductSelectSwatch_module_scss_1.default['arContainer--long']]: EpigraphModelViewer && optionElements.length > 3
    });
    return ((0, jsx_runtime_1.jsxs)("div", { className: className, "data-selector": dataSelector, children: [(0, jsx_runtime_1.jsx)(ProductLabel_1.default, { index: 0, label: options.displayName.toLowerCase(), hideQuantity: true, hideSize: hideSize, isCheckbox: false, swatchLabel: options === null || options === void 0 ? void 0 : options.selectedValueLabel, modalContentProps: { productCode, sku: productCode }, ...toggleProps }), (0, jsx_runtime_1.jsxs)("div", { className: swatchContainerClasses, children: [(0, jsx_runtime_1.jsx)(product_swatch_1.default, { size: size, optionsList: optionElements, onChange: onChange, productCode: productCode, initialSelection: options.selectedValue }), EpigraphModelViewer && EpigraphModelViewer] }), EpigraphDisclaimer && EpigraphDisclaimer] }));
};
ProductSelectSwatch.propTypes = {
    dataSelector: prop_types_1.default.string.isRequired,
    productCode: prop_types_1.default.string,
    attributeCode: prop_types_1.default.string,
    className: prop_types_1.default.string,
    size: prop_types_1.default.string,
    epigraphArButtonProps: prop_types_1.default.shape({
        EpigraphModelViewer: prop_types_1.default.node,
        EpigraphDisclaimer: prop_types_1.default.node
    }),
    toggleProps: prop_types_1.default.object,
    isOutOfStockStyling: prop_types_1.default.bool
};
exports.default = (0, react_1.memo)(ProductSelectSwatch);
//# sourceMappingURL=ProductSelectSwatch.js.map